import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import { analytics } from 'core/analytics';
import { staticURL } from 'core/url';

import Header from 'apps/components/header/header';
import Paragraph from 'components/Paragraph';

import { ContentIntro } from 'apps/components/contentIntro';
import { Environment } from 'apps/components/environment';
import DocumentHead from 'legacyComponents/documentHead';

import Join from 'apps/home/landing/sections/join';

import { Container, HeadingStyled, ImageStyled } from '../company.styled';

@withNamespaces()
@inject('routerStore', 'clientStore')
@observer
export class AboutUs extends React.Component {
  constructor() {
    super();
    analytics.sendEvent('ViewContent', {}, { twitter: true, facebook: true });
    analytics.linkedinPixel('1169129');
  }

  render() {
    const { clientStore } = this.props;
    return (
      <>
        <DocumentHead imagePath={staticURL('assets/wikifactory.jpg')} />
        <Header isDark alwaysSticky />
        <ContentIntro
          title='About Us'
          hideButtonWhenSignIn={true}
          variant='secondary'
          isCentered
        />
        <Container>
          <HeadingStyled level={2} size='large'>
            <Trans>What is Wikifactory?</Trans>
          </HeadingStyled>
          <Paragraph size='medium'>
            <Trans>
              Wikifactory is the place where great ideas become even better
              products. We’ve embedded an agile hardware product development{' '}
              <Environment name='workspace' /> within a very different type of
              social platform. One dedicated to productivity.
            </Trans>
          </Paragraph>
          <Paragraph size='medium'>
            <Trans>
              We’re over 90,000 members from 190 countries, and we’re growing
              fast. Our <Environment name='community' /> of product designers,
              engineers and enterprises comes together to design, prototype and
              manufacture hardware products in more agile ways. At Wikifactory
              we make the tools to do this, and we make them available to
              everyone.
            </Trans>
          </Paragraph>
          <HeadingStyled level={2} size='large'>
            ―
          </HeadingStyled>
          <Paragraph size='medium'>
            {/* TODO: add this source responsive images control for the image component */}
            <picture>
              <ImageStyled src={staticURL('/assets/home/how-it-works.jpg')} />
            </picture>
          </Paragraph>
          <HeadingStyled level={3} size='medium'>
            <Trans>Get your team on the internet.</Trans>
          </HeadingStyled>
          <Paragraph size='medium'>
            <Trans>
              Our cloud-based, product development{' '}
              <Environment name='workspace' /> enables collaboration with
              control in a single agile environment. Available to anyone,
              accessible anywhere.
            </Trans>
          </Paragraph>
          <HeadingStyled level={3} size='medium'>
            <Trans>Or get the internet on your team.</Trans>
          </HeadingStyled>
          <Paragraph size='medium'>
            <Trans>
              Join our <Environment name='community' />
              {', '}
              the world’s largest product design team, to explore new ideas,
              find or share expertise and showcase your innovation with the
              world.
            </Trans>
          </Paragraph>
          <HeadingStyled level={3} size='large'>
            ―
          </HeadingStyled>
          <HeadingStyled level={2} size='large'>
            <Trans>Why we’re doing it.</Trans>
          </HeadingStyled>
          <Paragraph size='medium'>
            <Trans>
              Our vision is to create an Internet of Production - bringing
              networked capability to digital product development and
              fabrication.
            </Trans>
          </Paragraph>
          <Paragraph size='medium'>
            <Trans>
              Just like the internet allows everyone to participate in the
              production and dissemination of ideas, a distributed
              infrastructure for physical products would mean anyone could
              participate in the design and production of physical things.
              Disrupting not just one industry, but industry itself.
            </Trans>
          </Paragraph>
          <Paragraph size='medium'>
            <Trans>
              By removing the barriers to participation, innovation and
              opportunity in product design and manufacturing, we want to help
              great ideas have a better chance and a bigger positive impact on
              our world. Almost half of the projects on Wikifactory are aligned
              with the UN’s Sustainable Development Goals. And we&apos;re proud
              to say that this the fastest growing project cluster on the
              platform.
            </Trans>
          </Paragraph>
          <HeadingStyled level={2} size='medium'>
            <Trans>
              By changing how things are made, we can make things change.
            </Trans>
          </HeadingStyled>
        </Container>
        {!clientStore.signedInProfile && <Join />}
      </>
    );
  }
}

AboutUs.propTypes = {
  clientStore: PropTypes.object,
};
